import { finalize } from 'rxjs/operators';

(() => {
	angular.module('main').controller('AdminController', AdminController);

	AdminController.$inject = [
		'$scope',
		'$q',
		'$filter',
		'$rootScope',
		'adminReportsDataService',
		'adminUsersDataService',
		'ambassadorService',
		'ambassadorsDataService',
		'validationService',
		'messageService',
		'paginationService'
	];

	function AdminController(
		$scope,
		$q,
		$filter,
		$rootScope,
		adminReportsDataService,
		adminUsersDataService,
		ambassadorService,
		ambassadorsDataService,
		validationService,
		messageService,
		paginationService
	) {
		document.title = 'Studio Ninja | Super Admin';
		$scope.usersData = null;
		$scope.filteredAdminTableData = null;
		$scope.reportTypes = [
			'New sign ups',
			'New paying members',
			'Total free members',
			'Total paying members',
			'Total revenue',
			'New cancellations'
		];
		$scope.selectedReportType = $scope.reportTypes[3];

		$scope.newSignUpsReport = null;
		$scope.newPayingMembersReport = null;
		$scope.newCancellationsReport = null;
		$scope.totalRevenueReport = null;
		$scope.synchronization = false;
		$scope.isDisabled = false;

		$scope.users = [];
		$scope.totalItems = 0;
		$scope.pageRequest = {
			filterBy: null,
			paging: {
				pageSize: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageNumber: 0,
				searchToken: null
			},
			sortCriteria: {
				fieldName: 'id',
				sortAscending: false
			}
		};
		$scope.userTwoFaSpinner = false;
		$scope.userTwoFaInfo = null;
		$scope.selectedAccountId = null;

		$scope.changeReportType = function() {
			switch ($scope.selectedReportType) {
				case $scope.reportTypes[0]:
					buildNewSignUpsReport();
					break;
				case $scope.reportTypes[1]:
					buildNewPayingMembersReport();
					break;
				case $scope.reportTypes[2]:
					buildTotalFreeMembersReport();
					break;
				case $scope.reportTypes[3]:
					buildTotalPayingMembersReport();
					break;
				case $scope.reportTypes[4]:
					buildTotalRevenueReport();
					break;
				case $scope.reportTypes[5]:
					buildNewCancellationsReport();
					break;
				default:
					break;
			}
		};

		// navigation
		$scope.searchRequest = search => {
			$scope.pageRequest.filterBy = search || null;
			$scope.pageRequest.paging.pageNumber = 0;
			getResultsPage(
				$scope.pageRequest.paging.pageNumber,
				$scope.pageRequest.paging.pageSize
			);
		};

		$scope.order = function(predicate) {
			$scope.pageRequest.sortCriteria.sortAscending =
				$scope.pageRequest.sortCriteria.fieldName === predicate
					? !$scope.pageRequest.sortCriteria.sortAscending
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.sortCriteria.sortAscending
			);
		};

		function getResultsPage(
			pageNumber = null,
			perPage = null,
			predicate = null,
			reverse = null
		) {
			const newPageRequest = paginationService.getResultsPage(
				$scope.pageRequest,
				$scope.totalItems,
				pageNumber,
				perPage,
				predicate,
				reverse
			);

			if (newPageRequest) {
				$scope.getAdminTableData(newPageRequest);
			}
		}

		$scope.$watch('$viewContentLoaded', () => {
			getResultsPage(
				$scope.pageRequest.paging.pageNumber,
				$scope.pageRequest.paging.pageSize
			);
			$rootScope.removeBg = 'white-background';
		});

		$scope.checkDisableButtons = event => {
			$scope.isDisabled = event;
		};

		$scope.giveFreeMonths = (
			setTimeConfiguration,
			userLocal,
			freeAccessMethod
		) => {
			if (
				!setTimeConfiguration.unitCount ||
				(setTimeConfiguration.unitCount && setTimeConfiguration.unitCount < 0)
			) {
				messageService.showToaster('e_0', 'admin');
				return;
			}

			$scope.btn_disable = true;

			adminUsersDataService
				.giveFreeAccess(
					setTimeConfiguration,
					userLocal.businessAccountId,
					freeAccessMethod
				)
				.finally(() => {
					setTimeConfiguration = {};
					$scope.btn_disable = false;
				})
				.subscribe(
					() => {
						successGiveFreeMonths(userLocal);
					},
					error => messageService.handleError(error)
				);
		};

		function successGiveFreeMonths(userLocal) {
			getResultsPage(
				$scope.pageRequest.paging.pageNumber,
				$scope.pageRequest.paging.pageSize
			);
			messageService.showToaster('s_0', 'admin', userLocal.email);
			$('#subscriptionModal').modal('hide');
		}

		$scope.getAdminTableData = pageRequest => {
			$scope.pageRequest = pageRequest;
			$rootScope.paginationPerPage = pageRequest.paging.pageSize;
			adminUsersDataService.getUsers(pageRequest).subscribe(
				data => successGetAdminTableData(data),
				err => {
					$scope.synchronization = false;
					messageService.showDefaultErrorMessage(err);
				}
			);
		};

		function successGetAdminTableData(data) {
			$scope.totalItems = data ? data.totalSize : 0;
			$scope.pageNumbers = paginationService.calculatePageNumbers(
				$scope.totalItems,
				$scope.pageRequest.paging.pageSize
			);

			$scope.changeReportType();
			$scope.usersData = data.items;
			$scope.newSignUpsReport = $scope.newSignUpsReport || null;
			$scope.newPayingMembersReport = $scope.newPayingMembersReport || null;
			$scope.newCancellationsReport = $scope.newCancellationsReport || null;
			$scope.totalRevenueReport = $scope.totalRevenueReport || null;
			$scope.synchronization = false;
			$scope.pageRequest.paging.searchToken = data.searchToken;
			parseDate();
		}

		function buildNewSignUpsReport() {
			if (!$scope.newSignUpsReport) {
				adminReportsDataService
					.getSignUpReport()
					.subscribe(data => {
						$scope.newSignUpsReport = data;
					})
					.catch(messageService.showDefaultErrorMessage);
			}
		}

		function buildNewPayingMembersReport() {
			if (!$scope.newPayingMembersReport) {
				adminReportsDataService
					.getPayingMembersReport()
					.catch(messageService.showDefaultErrorMessage)
					.subscribe(data => {
						$scope.newPayingMembersReport = data;
					});
			}
		}

		function buildTotalFreeMembersReport() {
			if (
				!$scope.newSignUpsReport ||
				!$scope.newPayingMembersReport ||
				!$scope.newCancellationsReport
			) {
				adminReportsDataService
					.getSignUpReport()
					.flatMap(data => {
						$scope.newSignUpsReport = data;
						return adminReportsDataService.getPayingMembersReport();
					})
					.flatMap(data => {
						$scope.newPayingMembersReport = data;
						return adminReportsDataService.getCancellationReport();
					})
					.catch(err => messageService.showDefaultErrorMessage(err))
					.subscribe(data => {
						$scope.newCancellationsReport = data;
					});
			}
		}

		function buildTotalPayingMembersReport() {
			if (!$scope.newPayingMembersReport || !$scope.newCancellationsReport) {
				adminReportsDataService
					.getPayingMembersReport()
					.catch(messageService.showDefaultErrorMessage)
					.flatMap(data => {
						$scope.newPayingMembersReport = data;
						return adminReportsDataService.getCancellationReport();
					})
					.subscribe(data => {
						$scope.newCancellationsReport = data;
					});
			}
		}

		function buildTotalRevenueReport() {
			if (!$scope.totalRevenueReport) {
				adminReportsDataService
					.getTotalRevenueReport()
					.catch(messageService.showDefaultErrorMessage)
					.subscribe(data => {
						$scope.totalRevenueReport = data;
					});
			}
		}

		function buildNewCancellationsReport() {
			if (!$scope.newCancellationsReport) {
				adminReportsDataService
					.getCancellationReport()
					.catch(messageService.showDefaultErrorMessage)
					.subscribe(result => {
						$scope.newCancellationsReport = result.data;
					});
			}
		}

		$scope.deleteModal = function(user) {
			$scope.deleteUser = user;
			$('#deleteModal').modal('show');
		};

		$scope.deleteRequest = function(deleteUser) {
			$scope.add_btn_disable = true;
			$scope.isAddSpinningWheelActive = true;
			adminUsersDataService
				.deleteUser(deleteUser.email)
				.pipe(
					finalize(() => {
						$scope.add_btn_disable = false;
						$scope.isAddSpinningWheelActive = false;
					})
				)
				.subscribe(
					() => {
						messageService.showToaster('s_2', 'admin', deleteUser.email);
						$('#deleteModal').modal('hide');
						delete $scope.deleteUser;
						$scope.usersData = deleteItemByEmail(
							$scope.usersData,
							deleteUser.email
						);
						getResultsPage(
							$scope.pageRequest.paging.pageNumber,
							$scope.pageRequest.paging.pageSize
						);
					},
					error => messageService.handleError(error)
				);
		};

		function deleteItemByEmail(array, email) {
			return array.filter(item => item.email && item.email !== email);
		}

		function parseDate() {
			const dateFormat = 'd MMMM yyyy';

			$scope.usersData.forEach(item => {
				item.registeredAt = $filter('date')(item.registeredAt, dateFormat);
				item.lastLogin = $filter('date')(item.lastLogin, dateFormat);
			});
		}

		$scope.show2FaModal = user => {
			$scope.userTwoFaSpinner = true;
			adminUsersDataService
				.getUserTwoFaInfo(user.businessAccountId)
				.finally(() => ($scope.userTwoFaSpinner = false))
				.subscribe(
					({ data }) => {
						if (!data.users.length) {
							messageService.showErrorFromBackend(
								'Whooops',
								'Seems like there are no users with 2FA set up on this account'
							);
							return;
						}
						$scope.userTwoFaInfo = data;
						$scope.selectedAccountId = user.businessAccountId;
						$('#manageUserTwoFaModal').modal('show');
					},
					({ error }) => {
						const { errorTitle, errorMessage } = error;
						messageService.showErrorFromBackend(errorTitle, errorMessage);
					}
				);
		};

		$scope.on2FaModalClose = () => {
			$scope.selectedAccountId = null;
			$('#manageUserTwoFaModal').modal('hide');
		};

		$scope.showSubscriptionModal = function(user) {
			adminUsersDataService
				.getSubscriptionInfoForFreeAccess(user)
				.subscribe(
					data => successGetUserInfo(data.data, user),
					error => messageService.handleError(error)
				);
		};

		function successGetUserInfo(data, user) {
			$scope.userInfoLocal = user;
			$scope.subscriptionInfo = data;
			$scope.currentPlan = data.currentPlan
				? Object.keys(data.currentPlan.properties)
				: null;
			$scope.remainingTime = convertSecondsToDaysAndHoursString(
				data.userInfo.freeTimeRemainingBalanceInSec
			);
			$('#subscriptionModal').modal('show');
		}

		$scope.showMakeAmbassadorModal = function(user) {
			$scope.userInfo = user;
			getAmbassadorInfo(user);
		};

		function prepareUser(user) {
			if (!user.startDate) {
				user.startDate = new Date();
				user.startDate.setHours(0, 0, 0, 0);
			}
		}

		function getAmbassadorInfo(user) {
			ambassadorService
				.getAmbassadorMetadata(user.businessAccountId)
				.subscribe(
					ambassador => successGetAmbassadorInfo(ambassador.data),
					error => messageService.handleError(error)
				);
		}

		function successGetAmbassadorInfo(ambassador) {
			prepareUser(ambassador);
			ambassador.startDate = new Date(ambassador.startDate);
			ambassador.endDate = new Date(ambassador.endDate);
			$scope.ambassador = angular.copy(ambassador);
			$('#addAmbassadorCodeModal').modal('show');
		}

		$scope.submitAmbassadorCode = ambassador => {
			$scope.btn_disable = true;
			const isExistedAmbassador = ambassador.isAmbassador;
			const ambassador2save = ambassadorService.validateAmbassador(ambassador);

			if (!ambassador2save) {
				$scope.btn_disable = false;
				return;
			}

			let action;
			if (isExistedAmbassador) {
				action = ambassadorsDataService.updateAmbassador(ambassador2save);
			} else {
				action = ambassadorsDataService.createAmbassador(ambassador2save);
			}

			action
				.then(() => {
					messageService.showToaster('s_3', 'admin', ambassador.email);
					$('#addAmbassadorCodeModal').modal('hide');
					getResultsPage(
						$scope.pageRequest.paging.pageNumber,
						$scope.pageRequest.paging.pageSize
					);
				})
				.catch(({ data }) => {
					const { errorMessage, errorTitle } = data;
					messageService.showErrorFromBackend(errorTitle, errorMessage);
				})
				.finally(() => {
					$scope.btn_disable = false;
				});
		};

		$scope.closeAccess = function(user) {
			$scope.closeAccessUser = user;
			$('#closeAccessModal').modal('show');
			getResultsPage(
				$scope.pageRequest.paging.pageNumber,
				$scope.pageRequest.paging.pageSize
			);
		};

		$scope.closeAccessRequest = closeAccessUser => {
			$scope.add_btn_disable = true;
			$scope.isAddSpinningWheelActive = true;
			adminUsersDataService
				.closeAccess(closeAccessUser.businessAccountId)
				.pipe(
					finalize(() => {
						$scope.add_btn_disable = false;
						$scope.isAddSpinningWheelActive = false;
					})
				)
				.subscribe(
					() => {
						messageService.showToaster('s_1', 'admin', closeAccessUser.email);
						$('#closeAccessModal').modal('hide');
						getResultsPage(
							$scope.pageRequest.paging.pageNumber,
							$scope.pageRequest.paging.pageSize
						);
					},
					error => {
						messageService.handleError(error);
					}
				);
		};

		function convertSecondsToDaysAndHoursString(seconds) {
			if (!seconds) return null;

			const daysData = Math.floor(seconds / (3600 * 24));
			const hoursData = Math.floor((seconds % (3600 * 24)) / 3600);
			const minutesData = Math.floor((seconds % 3600) / 60);
			let result = '';
			result +=
				daysData > 0 ? daysData + (daysData === 1 ? ' day ' : ' days ') : '';
			result +=
				hoursData > 0
					? hoursData + (hoursData === 1 ? ' hour ' : ' hours ')
					: '';
			result +=
				minutesData > 0 && !hoursData
					? minutesData + (minutesData === 1 ? ' minute ' : ' minutes ')
					: '';

			return result;
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/admin/adminControllers.js